/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_CarrierInputs */

const vi_box_label_carrier = /** @type {(inputs: Box_Label_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vận chuyển`)
};

/**

* @param {Box_Label_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_carrier = /** @type {((inputs?: Box_Label_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_carrier(inputs)
});